/* eslint-disable camelcase */
import React from 'react';
import rightArrow from '../../../../../assets/images/chevron-right-grey.svg';
import rightArrowHover from '../../../../../assets/images/chevron-right-blue.svg';
import { DropdownButton, DropdownNavLink } from '../../PrimaryNavLinksStyles';
import {
  MegaMenuColumns,
  MegaMenuBorderRight,
  NavTitle,
  MegaMenuHr,
  MegaMenuDropdown,
  MegaMenuAllLink,
  MegaMenuAllLinkA,
  MegaMenuArrow,
} from '../MegaMenuStyles';
import dropdown from '../../../../../assets/images/dropdown.svg';

import { LargeIconLinks, SmallIconHeaderLinks, HandleKeydown } from '../atoms';
import { Row } from '../../../../_atoms/grid';
import StyledMegamenuClose from '../atoms/MegamenuClose';
import { LazyLink } from '../../../../../../../../slices/atoms';
import { useMediaQuery } from '../../../../../../../../util/useMediaQuery';

const ProductsMegaMenu = (
  item,
  navigation,
  currentPath,
  openCurrentMegaMenu,
  closeMegaMenu,
  isMegaMenuOpen,
  currentMegaMenu,
) => {
  const { primary_navigation_text } = item;
  const {
    products_mega_menu_title,
    products_mega_menu_featured,
    products_mega_menu_secondary,
    bottom_link_text,
    bottom_link,
  } = navigation;

  const isMobile = useMediaQuery('(max-width: 1023px)');

  return (
    <>
      <DropdownButton
        onClick={() => {
          if (isMegaMenuOpen && currentMegaMenu === 'products') closeMegaMenu();
          openCurrentMegaMenu('products');
        }}
        key={primary_navigation_text}
        className="nav-item"
      >
        <DropdownNavLink
          role="button"
          tabIndex="0"
          aria-pressed="false"
          onKeyDown={e => {
            HandleKeydown(e);
          }}
          className={`${currentPath === 'products' && 'active'}`}
        >
          {primary_navigation_text}
        </DropdownNavLink>
        {!isMobile && <img className="dropdown" src={dropdown} />}
      </DropdownButton>

      {isMegaMenuOpen && currentMegaMenu === 'products' && !isMobile && (
        <MegaMenuDropdown id="productsMegaDropdown">
          <MegaMenuColumns>
            <MegaMenuBorderRight>
              <NavTitle className="products-title is-mega-menu-title">{products_mega_menu_title}</NavTitle>
              {LargeIconLinks(products_mega_menu_featured)}
            </MegaMenuBorderRight>
            <Row>{SmallIconHeaderLinks(products_mega_menu_secondary)}</Row>
          </MegaMenuColumns>

          <MegaMenuHr />

          <MegaMenuAllLink>
              <MegaMenuAllLinkA renderAs={LazyLink} url={bottom_link && bottom_link.url}>
                {bottom_link_text}
                {<MegaMenuArrow className="grey" src={rightArrow} alt="arrow" />}
                {<MegaMenuArrow className="blue" src={rightArrowHover} alt="arrow" />}
              </MegaMenuAllLinkA>
          </MegaMenuAllLink>
        </MegaMenuDropdown>
      )}

      {isMobile && (
        <MegaMenuDropdown id="productsMegaDropdown">
          <MegaMenuColumns>
            <MegaMenuBorderRight>
              <NavTitle className="products-title is-mega-menu-title">{products_mega_menu_title}</NavTitle>
              {LargeIconLinks(products_mega_menu_featured)}
            </MegaMenuBorderRight>
            <Row>{SmallIconHeaderLinks(products_mega_menu_secondary)}</Row>
          </MegaMenuColumns>

          <MegaMenuHr />

          <MegaMenuAllLink>
              <MegaMenuAllLinkA renderAs={LazyLink} url={bottom_link && bottom_link.url}>
                {bottom_link_text}
                {<MegaMenuArrow className="grey" src={rightArrow} alt="arrow" />}
                {<MegaMenuArrow className="blue" src={rightArrowHover} alt="arrow" />}
              </MegaMenuAllLinkA>
          </MegaMenuAllLink>
        </MegaMenuDropdown>
      )}

      {isMegaMenuOpen && !isMobile && <StyledMegamenuClose onClick={closeMegaMenu} />}
    </>
  );
};

export default ProductsMegaMenu;
